export default __webpack_public_path__ + "static/media/permission2.d544b404.png";